<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container">
  <div class="row justify-content-center">
    <h1 class="lifedi-color mb-5">
      วิจัย
    </h1>
  </div>
  <div class="row mt-3 mb-3" *ngIf="rows?.length === 0">
    <h4 class="text-center w-100">
      ยังไม่มีงานวิจัย
    </h4>
  </div>

  <div class="row" *ngIf="rows?.length > 0">
    <div *ngFor="let c of rows" class="col-lg-3 col-md-4 col-sm-6 mb-4">
      <lifedi-research-card [data]="c"></lifedi-research-card>
    </div>
  </div>


  <div class="d-flex justify-content-center p-2" *ngIf="rows">
    <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" (pageChange)="refresh()">
    </ngb-pagination>
  </div>
</div>
